
// projects page swiper
$(document).ready(function () {

  //swiper on project page
  var mySwiper = new Swiper('[data-project-swiper]', {
    loop: true,
    pagination: {
      el: '[data-project-swiper-pagination]',
    },
    navigation: {
      nextEl: '[data-project-swiper-next]',
      prevEl: '[data-project-swiper-prev]',
    },
  })
});